// src/components/BookList.jsx
import React from "react";
import { motion } from "framer-motion";

const books = [
  {
    subject: "History",
    items: [
      "Ancient & Medieval India – NCERT (Class XI, XII), Ancient India (R. S. Sharma), Medieval India (Satish Chandra)",
      "Modern India – A Brief History of Modern India (Spectrum – Rajiv Ahir), India’s Struggle for Independence (Bipan Chandra)",
      "World History (Mains GS-I) – Mastering Modern World History (Norman Lowe)",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "Geography",
    items: [
      "Physical Geography – Certificate Physical & Human Geography (G. C. Leong)",
      "Indian Geography – NCERT VI–XII, Geography of India (Majid Husain)",
      "Atlas – Orient Black Swan Atlas or Oxford Atlas",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "Polity",
    items: [
      "Indian Polity (M. Laxmikanth)",
      "Introduction to the Constitution of India (D. D. Basu)",
      "Our Parliament (Subhash Kashyap)",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "Economy",
    items: [
      "Indian Economy (Ramesh Singh)",
      "Indian Economy (Nitin Singhania)",
      "NCERT XI – Indian Economic Development",
      "Economic Survey & Union Budget (for current updates)",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "Environment & Ecology",
    items: [
      "NCERT Biology Class XII (relevant chapters)",
      "Reports: IPCC, WWF, State of Environment reports",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "Science & Technology",
    items: [
      "NCERTs (Class IX & X – basics)",
      "Newspaper coverage of current developments",
      "Science Reporter magazine (selected issues)",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "Ethics (GS Paper IV)",
    items: [
      "Ethics, Integrity & Aptitude (Subba Rao & P. N. Roy Choudhary)",
      "Lexicon for Ethics (Chronicle)",
      "2nd ARC Reports (relevant chapters)",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "Current Affairs",
    items: [
      "Newspapers – The Hindu / Indian Express",
      "Magazines – Yojana, Kurukshetra",
      "PIB (Press Information Bureau) updates",
      "Monthly compilations by Selva’s IAS Academy",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
  {
    subject: "CSAT (Prelims Paper II)",
    items: [
      "Analytical Reasoning (M. K. Pandey)",
      "A Modern Approach to Verbal & Non-Verbal Reasoning (R. S. Aggarwal)",
      "CSAT Manual (Tata McGraw Hill / Pearson)",
    ],
  },
  {
    subject: "Optional Subject",
    items: [
      "Anthropology – Anthropology (P. Nath), Indian Anthropology (Nadeem Hasnain), IGNOU, EPG Pathashala",
      "Selva’s IAS Academy Study Materials.",
    ],
  },
];

export default function BookList() {
  return (
    <section  id="booklist" className="w-full bg-gray-50 py-12 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-900 mb-10">
          Recommended Books – Subject Wise
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
          {books.map((book, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="bg-white shadow-sm rounded-xl p-6 border-t-4 border-indigo-500 hover:shadow-lg"
            >
              <h3 className="text-lg font-semibold text-red-700 mb-3">
                {book.subject}
              </h3>
              <ul className="text-gray-700 text-sm space-y-2">
                {book.items.map((item, i) => (
                  <li key={i}>• {item}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
